import React from 'react';
import { motion } from 'framer-motion';
import { insideLook } from '../data/content';
export function InsideLook() {
  return <section className="w-full bg-slate-50 py-16 sm:py-24" aria-labelledby="inside-look-title" data-id="element-116" data-mp="2c9slif2c106x">
      <div className="mx-auto max-w-6xl px-6" data-id="element-117" data-mp="1yajg8afnzqhq">
        <div className="mx-auto max-w-3xl text-center" data-id="element-118" data-mp="238bahb3s7op3">
          <h2 id="inside-look-title" className="text-3xl font-extrabold leading-tight tracking-tight text-navy-deep sm:text-4xl" data-id="element-119" data-mp="238ur8ohp471j">
            A Real Look Inside The System
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink/75" data-id="element-120" data-mp="2v1ldc65o0fd2">
            Step-by-step protocols, visual reference tables, and printable tools — explained clearly
            for any family.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-121" data-mp="39x1e0u0r39if">
          {insideLook.map((page, index) => <motion.figure key={page.src} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: index * 0.08,
          ease: 'easeOut'
        }} className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-122" data-mp="3en828srcos05" data-mpi={index}>
              <img src={page.src} alt={page.caption} className="aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-123" data-mp="26v8h51zpx88f" />
              <figcaption className="border-t border-slate-100 px-5 py-4 text-sm font-medium text-ink/70" data-id="element-124" data-mp="2gl1uo8jf7xfb">
                {page.caption}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}